import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 mt-auto">
      <div className="container mx-auto px-4 text-center">
        <p>Contact us: <a href="mailto:info@team-skynet.io" className="text-blue-300 hover:text-blue-200">info@team-skynet.io</a></p>
        <p className="text-sm mt-2">&copy; {new Date().getFullYear()} Team Skynet. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
